// Utility function to scroll to top of page
export const scrollToTop = () => {
  window.scrollTo(0, 0);
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};
